import {
  type AlertIconProps as ChakraAlertIconProps,
  chakra,
} from '@chakra-ui/react-v2';
import { cx } from '@chakra-ui/utils';

import {
  OutlineCircleInfoIcon,
  OutlineCircleCheckmarkIcon,
  OutlineCircleExclamationMarkIcon,
  OutlineCircleXIcon,
  AssistanceIcon,
} from '@frontend/legacy-components/src/components/mediaAndIcons/icons/iconSet';

import { useAlertContext, useAlertStyles } from './utils/AlertContext';

const ICON_BY_STATUS = {
  info: OutlineCircleInfoIcon,
  warning: OutlineCircleExclamationMarkIcon,
  error: OutlineCircleXIcon,
  success: OutlineCircleCheckmarkIcon,
  assistance: AssistanceIcon,
};

export type AlertIconProps = ChakraAlertIconProps & {
  icon?: React.ElementType;
};

export const AlertIcon = ({
  className,
  icon,
  ...restProps
}: AlertIconProps) => {
  const { status } = useAlertContext();
  const BaseIcon = icon ?? ICON_BY_STATUS[status];
  const { icon: iconStyles } = useAlertStyles();

  return (
    <chakra.span
      display="inherit"
      className={cx('chakra-alert__icon', className)}
      __css={iconStyles}
      {...restProps}
    >
      <BaseIcon w="100%" h="100%" />
    </chakra.span>
  );
};
